
import { defineMessages } from 'react-intl';

export const AMAZONPAY = 'amazonpay';
export const AMERICAN_EXPRESS = 'american_express';
export const APPLEPAY = 'applepay';
export const MASTERCARD = 'mastercard';
export const PAYPAL = 'paypal';
export const SEPA = 'sepa';
export const SOFORT = 'sofort';
export const VISA = 'visa';
export const AFTERPAY = 'afterpay';
export const CLEARPAY = 'clearpay';

export const PaymentMethods = {
  Visa: 'visa',
  Mastercard: 'mastercard',
  AmericanExpress: 'american_express',
  PayPal: 'paypal',
  ApplePay: 'applepay',
  AmazonPay: 'amazonpay',
  Sofort: 'sofort',
  AfterPay: 'afterpay',
  Clearpay: 'clearpay',
};

(PaymentMethods as any).defaults = [
  PaymentMethods.Visa,
  PaymentMethods.Mastercard,
  PaymentMethods.AmericanExpress,
  PaymentMethods.PayPal,
  PaymentMethods.ApplePay,
];

const messages = defineMessages({
  visa: {
    id: 'react.headerAndFooter.components.Footer.visa',
    defaultMessage: 'Visa',
  },
  mastercard: {
    id: 'react.headerAndFooter.components.Footer.mastercard',
    defaultMessage: 'MasterCard',
  },
  american_express: {
    id: 'react.headerAndFooter.components.Footer.american_express',
    defaultMessage: 'American Express',
  },
  paypal: {
    id: 'react.headerAndFooter.components.Footer.paypal',
    defaultMessage: 'PayPal',
  },
  applepay: {
    id: 'react.headerAndFooter.components.Footer.applepay',
    defaultMessage: 'Apple pay',
  },
  amazonpay: {
    id: 'react.headerAndFooter.components.Footer.amazonpay',
    defaultMessage: 'Amazon Pay',
  },
  sofort: {
    id: 'react.headerAndFooter.components.Footer.sofort',
    defaultMessage: 'Sofort',
  },
  afterpay: {
    id: 'react.headerAndFooter.components.Footer.afterpay',
    defaultMessage: 'AfterPay',
  },
  clearpay: {
    id: 'react.headerAndFooter.components.Footer.clearpay',
    defaultMessage: 'Clearpay',
  },
});

export const availablePaymentMethods = (intl?: any, paymentMethods?: any) => {
  return paymentMethods.map((paymentMethod?: any) => {
    return {
      icon: paymentMethod,
      text: intl.formatMessage(messages[paymentMethod]),
    };
  });
};
